module.exports = __webpack_public_path__ + "media/images/télévision-cd08e820f53d233b67df7d23d1f2a910.svg";